import { Grid } from '@mui/material'
import PatientSelectionCard from './PatientSelectionCard'
import { Patient } from '@/core/models/patient.model'

type PatientSelectionCardsProps = {
  primaryPatient?: Patient
  secondaryPatient?: Patient
  onUnselect: (patientId: string) => void
}

export function PatientSelectionCards({ primaryPatient, secondaryPatient, onUnselect }: PatientSelectionCardsProps) {
  return (
    <div>
      <Grid container spacing={3}>
        {primaryPatient && (
          <Grid item xs={12} md={6}>
            <PatientSelectionCard patient={primaryPatient} type="primary" onUnselect={onUnselect} />
          </Grid>
        )}
        {secondaryPatient && (
          <Grid item xs={12} md={6}>
            <PatientSelectionCard patient={secondaryPatient} type="secondary" onUnselect={onUnselect} />
          </Grid>
        )}
      </Grid>
    </div>
  )
}
